import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PhoneNumberHelper {
  public parse(text: string) {
    if (this.hasSpecialCharacters(text))
      return this.removeSpecialCharacters(text);

    return text.trim();
  }

  private hasSpecialCharacters(text: string): boolean {
    return /^[\d\s()+-]+$/.test(text);
  }

  private removeSpecialCharacters(text: string): string {
    return text.replace(/\D/g, '');
  }
}
